import type { CSSProperties } from "react";
import Theme from "@/utils/theme";

export type IconProps = {
  size?: number;
  color?: string;
  style?: CSSProperties;
};

export const defaultIconProps: { size: number; color: string } = {
  size: 24,
  color: Theme.colors.icon.default,
};
